import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TimesheetlistPage } from '../../pages/timesheetlist/timesheetlist';
import{ GlobalProvider } from '../../providers/global/global';

/**
 * Generated class for the FilterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-filter',
  templateUrl: 'filter.html',
})


export class FilterPage {

  // status: string = "0";
  // period: string = "0";

  constructor(public global: GlobalProvider,public navCtrl: NavController, public navParams: NavParams) {

    //this.global.status = this.global.setStatus(this.global.contacttype);
    // console.log('period:' + this.global.period);
    // console.log('status:' + this.global.status);
  }


  go_to_timesheets(){
    // this.navCtrl.push(Timesheets3Page,{status: this.status, period: this.period});
    // console.log('period:' + this.global.period);
    // console.log('status:' + this.global.status);
    localStorage.setItem('Status', this.global.status);
    this.navCtrl.setRoot(TimesheetlistPage);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FilterPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/filter/filter.ts